import enableBindingToOthers from '../../mvvm/enableBindingToOthers';
import PropertyBindingFactory from '../../mvvm/PropertyBindingFactory';
import BabylonViewBase from './BabylonViewBase';
import Vector3 from '../../geometry/Vector3';
import Iterator from '../../core/Iterator';
import SiteView from './SiteView';
import GenericView from './GenericView';
import ProgressBar from '../ProgressBar';
import Urls from '../../urls/Urls';
export default class SitePlan3DView extends BabylonViewBase{
	constructor(props){
		super(props);
		const {model, element, babylonScene, babylonModelsManager}=props;
		this._model = model;
		this._element = element;
		this._babylonScene=babylonScene;
		this._babylonModelsManager = babylonModelsManager;
		this._unitViews = [];
		this.initialize = this.initialize.bind(this);
		this._progressBarVisibleChanged = this._progressBarVisibleChanged.bind(this);
		enableBindingToOthers(this);
		PropertyBindingFactory.standard(this, model, 'zoom', this._zoomChanged);
		this._progressBar = new ProgressBar({model:model, propertyNameProgressProportion:'loadProgressProportion', propertyNameVisible:'progressBarVisible', delayHide:0});
		this._logoLarge = document.createElement('img');
		this._logoLarge.src = Urls.assets+'logos/large.png';
		this._logoLarge.classList.add('logo-large');
		this._element.appendChild(babylonScene.element);
		this._element.appendChild(this._progressBar.element);
		this._element.appendChild(this._logoLarge);
		this._bindingProgressBarVisible = PropertyBindingFactory.standard(this, model, 'progressBarVisible', this._progressBarVisibleChanged);
	}
	get element(){
		return this._element;
	}
	initialize(){
		const self = this;
		return new Promise((resolve, reject)=>{
			const siteView = new SiteView({
				model:this._model, 
				babylonScene:self._babylonScene, 
				babylonModelsManager:self._babylonModelsManager, 
				babylonMaterialsManager:self._babylonMaterialsManager});
			siteView.initialize().then(()=>{
				resolve();
			}).catch(reject);
		});
	}
	_zoomChanged(value){
		
	}
	_progressBarVisibleChanged(value){
		if(value)this._logoLarge.classList.add('visible');
		else this._logoLarge.classList.remove('visible');
	}
}
